import { useEffect } from 'react'
import { useIdentityStatus } from '@/entities/patient'
import { useAppDispatch } from '@/redux/rootReducer'
import { replaceAlerts } from '@/redux/reducers/alerts.reducer'
import { INFO_PATIENT_PAGE_ALERTS } from './constants'

export function usePatientAlerts(patientId: string) {
  const dispatch = useAppDispatch()

  const { error: checkIdentityStatusError } = useIdentityStatus(patientId)

  useEffect(() => {
    return () => {
      dispatch(replaceAlerts({ area: INFO_PATIENT_PAGE_ALERTS, alerts: [] }))
    }
  }, [dispatch])

  useEffect(() => {
    if (checkIdentityStatusError && 'error' in checkIdentityStatusError) {
      dispatch(replaceAlerts({ area: INFO_PATIENT_PAGE_ALERTS, alerts: [{ message: checkIdentityStatusError.error, type: 'error' }] }))
    }
  }, [dispatch, checkIdentityStatusError])
}
